import classNames from "classnames";

export const classModuleGrouping = (styles, strngs) => {
  return classNames(strngs.split(" ").map((arg) => styles[arg]));
}
